import {
  IDaySize, IMeeting, IWorkCalendarDay, getWeekDayIndex, isNonWorkingDay,
  setClass, shortMonths, useOutsideClick,
} from '@utils';
import { observer } from 'mobx-react-lite';
import React, { FC, useCallback } from 'react';
import { HolidayIcon, SvgWrapperTooltipSupport } from '@components';
import { Meetings } from './Meetings';
import { DayIcon } from '../../../components';

interface DayProps {
  currentDay: Date;
  isActiveDay?: boolean;
  className: string;
  size: IDaySize;
  getMeetings: (day: Date) => IMeeting[];
  setActiveDay: (day: string) => void;
  workCalendarDay: IWorkCalendarDay;
}

export const Day: FC<DayProps> = observer(({
  currentDay, isActiveDay, className, size, setActiveDay: setActiveDayProp, getMeetings, workCalendarDay,
}) => {
  const ref = useOutsideClick(() => setActiveDayProp(''));
  const setActiveDay = useCallback(() => setActiveDayProp(currentDay.toLocaleDateString()), []);
  const isWeekendHoliday = isNonWorkingDay(getWeekDayIndex(currentDay), workCalendarDay);

  return (
    <div
      className={setClass('wrapper-day', isActiveDay && 'active')}
      style={{
        width: size.width,
        height: size.height,
      }}
    >
      <div
        className={setClass('day', isActiveDay && 'active', isWeekendHoliday && 'weekend-holiday')}
        ref={isActiveDay ? ref : undefined}
      >
        <span className={className}>
          <span className="number-of-day">
            {currentDay.getDate()}
          </span>
          {currentDay.getDate() === 1 && shortMonths[currentDay.getMonth()]}
          {workCalendarDay
          && (
            <DayIcon workCalendarDay={workCalendarDay} />
          )}
        </span>

        <Meetings
          meetings={getMeetings(currentDay)}
          height={size.height}
          isActiveDay={isActiveDay}
          onClickShowMore={setActiveDay}
          isWeekendHoliday={isWeekendHoliday}
        />
      </div>
    </div>
  );
});
